module.exports = "pegasus/assets/theme2/large/1.jpg";